const DocumentCaptureContainerId = 'document-container';

const FontFamily = "'Geist', sans-serif";

const getOnfidoCustomization = (darkMode = false): Record<string, string | number> => {
  interface ThemeColors {
    backgroundIconButton: string;
    borderSurfaceModal: string;
    titleText: string;
    subtitleText: string;
    backgroundSurfaceModal: string;
    colorBackgroundInput: string;
    primary: string;
    hyperlink: string;
    primaryHoverOpacity30: string;
    primaryHover: string;
    primaryButtonBorder: string;
    textInputBorder: string;
    icon: string;
    buttonText: string;
    secondaryButtonText: string;
  }

  const darkTheme: ThemeColors = {
    backgroundIconButton: '#A3A3A3',
    borderSurfaceModal: '#64748B',
    titleText: '#E5E7EB',
    subtitleText: '#FFF1F2',
    buttonText: '#FFFFFF',
    secondaryButtonText: '#FFFFFF',
    backgroundSurfaceModal: '#1E293B',
    colorBackgroundInput: '#0A09194C',
    primary: '#7C75FF',
    hyperlink: '#A5B4FC',
    primaryHoverOpacity30: '#5B53FF26',
    primaryHover: '#5B53FF',
    primaryButtonBorder: '#FFFFFF4C',
    textInputBorder: '#FFFFFF26',
    icon: '#A5B4FC',
  };

  const lightTheme: ThemeColors = {
    backgroundIconButton: '#A3A3A3',
    borderSurfaceModal: '#64748B',
    titleText: '#0A0919',
    subtitleText: '#0A0919',
    buttonText: '#FFFFFF',
    secondaryButtonText: '#0A0919',
    backgroundSurfaceModal: '#FFFFFF',
    colorBackgroundInput: '#FFFFFF',
    primary: '#7C75FF',
    hyperlink: '#A5B4FC',
    primaryHoverOpacity30: '#5B53FF26',
    primaryHover: '#5B53FF',
    primaryButtonBorder: '#FFFFFF4C',
    textInputBorder: '#D4D4D4',
    icon: '#7C75FF',
  };

  const colors = darkMode ? darkTheme : lightTheme;

  const customization = {
    // Back and X Buttons
    colorBackgroundButtonIconActive: colors.backgroundIconButton,
    colorBackgroundButtonIconHover: colors.backgroundIconButton,

    // Main modal
    colorBorderSurfaceModal: colors.borderSurfaceModal,
    colorBackgroundSurfaceModal: colors.backgroundSurfaceModal,
    borderStyleSurfaceModal: '0px',
    borderRadiusButton: '50px',

    // Icons
    colorContentInfoPill: colors.subtitleText,
    colorBackgroundInfoPill: colors.primary,
    colorIcon: colors.icon,
    colorBackgroundIcon: colors.hyperlink,

    // Links
    colorBorderLinkUnderline: colors.hyperlink,
    colorBackgroundLinkActive: 'transparent',
    colorBackgroundLinkHover: 'transparent',
    colorContentLinkTextHover: colors.primary,

    // Titles
    fontSizeSubtitle: '16px',
    fontSizeTitle: '30px',
    fontFamilyTitle: FontFamily,
    fontFamilySubTitle: FontFamily,
    fontFamily: FontFamily,
    colorContentTitle: colors.titleText,
    colorContentSubtitle: colors.subtitleText,

    // Normal text
    fontFamilyBody: FontFamily,
    fontWeightBody: 400,
    fontSizeBody: '16px',
    colorContentBody: colors.subtitleText,

    // Document Type Selection
    colorBorderDocTypeButton: colors.primary,
    colorBorderDocTypeButtonHover: colors.primary,
    colorBorderDocTypeButtonActive: colors.primary,
    colorBackgroundDocTypeButton: colors.primaryHoverOpacity30,
    colorBackgroundDocTypeButtonHover: colors.primaryHoverOpacity30,
    colorBackgroundDocTypeButtonActive: colors.primaryHoverOpacity30,
    colorContentDocTypeButton: colors.primary,

    // Primary Action Buttons
    colorBorderButtonPrimary: colors.primaryButtonBorder,
    colorBorderButtonPrimaryHover: colors.primaryButtonBorder,
    colorBorderButtonSecondary: colors.primary,
    colorContentButtonPrimaryText: colors.buttonText,
    colorBackgroundButtonPrimary: colors.primary,
    colorBackgroundButtonPrimaryHover: colors.primaryHover,
    colorBackgroundButtonPrimaryActive: colors.primary,

    // Secondary Action Buttons
    colorContentButtonSecondaryText: colors.secondaryButtonText,
    colorBackgroundButtonSecondary: 'transparent',
    colorBackgroundButtonSecondaryHover: colors.primaryHoverOpacity30,
    colorBackgroundButtonSecondaryActive: colors.primaryHoverOpacity30,

    // Country dropdown sheet
    colorBackgroundSelector: colors.backgroundSurfaceModal,

    colorInputOutline: colors.primary,
    colorContentInput: colors.subtitleText,
    colorBackgroundInput: colors.colorBackgroundInput,
    colorBorderInput: colors.textInputBorder,

    // Info/alert box
    colorContentAlertInfo: colors.subtitleText,
    colorContentAlertError: colors.subtitleText,
  };
  return customization;
};

export default {
  DocumentCaptureContainerId,
  getOnfidoCustomization,
};
